module.exports = __webpack_public_path__ + "img/technology_thumbnail-1-400x300.fd16bd8f.jpg";